import user from '@/stores/user';

export function useToggleTheme() {
    function toggle() {
        user.toggleTheme();
    }

    return toggle;
}
